import { useState } from 'react';
import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import { Checkbox, Column, Dialog, DialogHeader, DialogContent, DialogFooter, Button, Grid } from '@pocketlaw/tetris';
import { useEsigning } from 'app/domains/esigning/components/EsigningProvider';
export function RemoveScriveRecipientDialog(props) {
    const { onClose } = props;
    const { cancelSignRequest } = useEsigning();
    const [checked, setChecked] = useState(false);
    const handleChange = () => {
        setChecked((value) => !value);
    };
    const handleSubmit = () => {
        onClose();
        cancelSignRequest();
    };
    return (<Dialog size="sm" onClose={onClose}>
      <DialogHeader title={t({
            comment: 'Cancel eSigning for one user with Scrive - dialog title',
            message: 'Cancel eSigning',
        })}/>
      <DialogContent>
        <Grid directions="vertical" spacing={4}>
          <Column width="100%">
            <Trans comment="Cancel eSigning for one user with Scrive - dialog body text">
              Scrive does not allow you to withdraw for one user. By continuing you will cancel the e-signing process
              for all parties.
            </Trans>
          </Column>
          <Column width="100%">
            <Checkbox checked={checked} onChange={handleChange} label={t({
            comment: 'Cancel eSigning for one user with Scrive - dialog checkbox label',
            message: 'I want to cancel eSigning for all parties',
        })}/>
          </Column>
        </Grid>
      </DialogContent>
      <DialogFooter>
        <Button type="button" appearance="secondary" onClick={onClose}>
          <Trans comment="Cancel eSigning for one user with Scrive - dialog cancel button label">Cancel</Trans>
        </Button>
        <Button type="submit" disabled={!checked} onClick={handleSubmit}>
          <Trans comment="Cancel eSigning for one user with Scrive - dialog confirm button label">Confirm</Trans>
        </Button>
      </DialogFooter>
    </Dialog>);
}
